export default __webpack_public_path__ + "static/media/honda-icons.c67e852e.ttf";